import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppShell } from '@/components/layout/AppShell';
import { PageContainer } from '@/components/layout/PageContainer';
import { TopBar } from '@/components/layout/TopBar';
import { Button } from '@/components/ui/Button';
import { useBookingDetails, useCancelBooking } from '@/api/queries/booking';
import { useUIStore } from '@/store/ui';
import { paths } from '@/routes/paths';
import { BoardingPass } from '@/components/domain/BoardingPass';
import { Spinner } from '@/components/ui/Spinner';

export function BoardingActionsPage(): JSX.Element {
  const { t } = useTranslation();
  const { id = '' } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const booking = useBookingDetails(id);
  const cancel = useCancelBooking(id);
  const pushToast = useUIStore((s) => s.pushToast);

  const handleTaxi = () => pushToast({ body: t('common.coming_soon'), variant: 'info' });
  const handleCancel = async () => {
    try {
      await cancel.mutateAsync();
      pushToast({ body: t('booking.actions.cancel_flight'), variant: 'success' });
      navigate(paths.home, { replace: true });
    } catch {
      pushToast({ body: t('errors.generic'), variant: 'error' });
    }
  };

  return (
    <AppShell>
      <PageContainer>
        <TopBar back title={t('booking.ticket_title')} bell />
        {booking.isLoading && <Spinner />}
        {booking.data && <BoardingPass booking={booking.data} />}

        <Button block size="lg" variant="primary" onClick={handleTaxi}>
          {t('booking.actions.order_taxi')}
        </Button>
        <Button block size="lg" variant="secondary" onClick={() => navigate(paths.travelFlightSearch)}>
          {t('booking.actions.order_another')}
        </Button>
        <Button block size="lg" variant="danger" onClick={handleCancel} loading={cancel.isPending}>
          {t('booking.actions.cancel_flight')}
        </Button>
      </PageContainer>
    </AppShell>
  );
}
